<label>
  <input
    type="number"
    inputmode="numeric"
    step="0.1"
    [(ngModel)]="weightService.weights[reference.entity][reference.weightField]"
    (change)="change()"
    (blur)="validate(reference.entity, reference.weightField)"
    max="{{ maxWeight }}"
    min="{{ minWeight }}"
    [disabled]="isDisabled"
    value="{{ weightService.weights[reference.entity][reference.weightField] }}"/>
</label>
